import React from 'react';
import styles from './PatternUnit.scss';
import cn from 'clsx';
import { getDataAttributes } from '@wix/editor-elements-common-utils';
import type { TextEffectsSharedData } from '../../TextEffectsShared.types';

export interface PatternUnitProps {
  className?: string;
  disabledPattern?: boolean;
  patternScope: TextEffectsSharedData['patternScope'];
  ariaHidden?: boolean;
  [key: `data-${string}`]: string | undefined;
}

const PatternUnit: React.FC<
  React.PropsWithChildren<PatternUnitProps>
> = props => {
  const {
    children,
    className,
    disabledPattern,
    ariaHidden,
    patternScope,
    ...rest
  } = props;

  return (
    <span
      className={cn(styles.container, className, {
        [styles.disabled]: disabledPattern,
        [styles.characterScope]: patternScope === 'character',
      })}
      {...getDataAttributes(rest)}
      {...(ariaHidden && { 'aria-hidden': true })}
    >
      {children}
    </span>
  );
};

export { PatternUnit };
